export const API_URL = "https://ekocrop-test.ekoniva-apk.org/api";
// export const API_URL = "https://ekocrop.ekoniva-apk.org/api";
// export const API_URL = "https://ekoniva-dev.freeddns.org/api";
